import React from "react";
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";

const TreeMapChart = (props) => {
  const {
    data=[],
    events,
    labelFormatter,
    onChartClick,
    toolTipConfig,
  } = props;

  const getOption = () => {
    data.map(item => ({
      ...item,
      fullName: item.name, // preserve original name for tooltip
      name: `${item.name} (${item.value})` // for display in chart
    }));
    let option = {
      tooltip: toolTipConfig ? { ...toolTipConfig } : {
        formatter: function (info) {
          console.log(info);
          return [
            '<div class="tooltip-title">' +
              info.data.fullAppName + " : " + info.data.value +
              "</div>",
          ].join("");
        },
      },
      series: [
        {
          type: "treemap",
          nodeClick: undefined,
          data: [
            {
              children: data,
            },
          ],
          color: [
            "#3B93A5",
            "#F7B844",
            "#00a0cc",
            "#EC3C65",
            "#1bc5b2",
            "#5e355f",
            "#D43F97",
            "#1E5D8C",
            "#421243",
            "#7F94B0",
            "#EF6537",
          ],
          roam: false,
          label: {
            show: true,
            formatter: labelFormatter || function (params) {
              return `${params.name.replace(/\s\(\d+\)$/, '')}\n(${params.value})`;
            },
            fontSize: 11,
            color: "#fff",
            align: "center",
            verticalAlign: "middle"
          },
          breadcrumb: {
            show: false,
          },
        },
      ],
    };
    return option;
  };
  //clickEvent
  const handleChartClick = (params) => {
    onChartClick(params);
  };

  // Legend select event handler
  const handleLegendSelectChanged = () => {
  };

  const onEvents = {
    click: handleChartClick, // chart click event
    legendselectchanged: handleLegendSelectChanged, // legend click event
  };
  return (
    <ReactECharts option={getOption()} onEvents={events ? onEvents : ""} />
  );
};

TreeMapChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  events: PropTypes.bool,
  labelFormatter: PropTypes.func,
  onChartClick: PropTypes.func.isRequired,
};
export default React.memo(TreeMapChart);



